export class NotificationModel {
  constructor(public message: string, public type: MessageType, public summary?: string, public icon?: string, public life?: number) {}
}

export enum MessageType {
  Danger = 'error',
  Success = 'success',
  Warning = 'warn',
  Info = 'info',
  Secondary = 'secondary',
}
